'use client';

import type { ReactNode } from 'react';
import { useActiveExperiment } from '$util/abTest';
import type { ActiveExperiments } from '$util/abTest/experiments';

interface ABTestProps {
  readonly experimentName: ActiveExperiments;
  readonly original: ReactNode;
  readonly bVariant: ReactNode;
}

/**
 * Component to render an A/B test.
 *
 * @note Use when you want to pass the variants as Server Components
 * and have the client only picking the active variant to render.
 *
 * @usage
 * ```tsx
 * <ABTest
 *  experimentName={ActiveExperiments.MyExperiment}
 *  original={<div>Original</div>}
 *  bVariant={<div>B Variant</div>}
 * />
 * ```
 */
export function ABTest({ experimentName, original, bVariant }: ABTestProps): ReactNode {
  // DEV: simulate activation of the experiment on the client
  // const isBVariant = useRenderAfterHydration(() => typeof window !== 'undefined');
  const isBVariant = useActiveExperiment(experimentName, 'B');
  if (isBVariant) return bVariant;
  return original;
}
